import { useState } from "react";
import { useMutation } from "@apollo/client";
import UseFormHandle from "../../../../GlobalHooks/UseFormHandle";
import { GetApolloErrorText } from "../../../../GlobalFunctions/helper";
import { UseNotification } from "../../../Notification/Library/UseNotification";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { BULK_EDIT_PRODUCT_PRICE } from "../../Queries/bulkPriceEdit";

const UseSendBulkPriceData = (lang, allLanguageMutations, Callback) => {
    const { AddNotification } = UseNotification();
    const { t } = useTranslation();

    const [processingItems, setProcessingItems] = useState([]); // místo useRef

    const { formData, SetFormData, SetCompleteFormData } = UseFormHandle({
        selectedLang: "",
        operationType: "add",
        id: "",
        isPercentage: 0,
        productType: "product", // product or variant
        productSourceType: "manufacturer", // from category or from supplier
        manufacturerID: 0,
        categoryID: 0,
        subCategoryID: 0,
        value: {
            cz: "",
            sk: "",
        },
        priceEditStarted: false,
        allLanguageMutations: allLanguageMutations,
    });

    useEffect(() => {
        SetCompleteFormData({ ...formData, allLanguageMutations });
    }, [allLanguageMutations]);

    useEffect(() => {
        SetCompleteFormData({ ...formData, selectedLang: lang });
    }, [lang]);

    const [BulkEditProductPrice] = useMutation(BULK_EDIT_PRODUCT_PRICE);

    const StartBulkEdit = async (content, CallBack) => {
        // sestavím pole vybraných položek
        const items = [];
        content.forEach((item) => {
            if (item.selected) items.push(item);
            if (Array.isArray(item.subData)) item.subData.filter((s) => s.selected).forEach((s) => items.push(s));
        });

        if (items.length === 0) {
            AddNotification(t("SelectAtLeastOneProduct"), false);
            return;
        }
        if (!formData.value || Object.values(formData.value).every((v) => v === "")) {
            AddNotification(t("SelectAtLeastOnePriceOrPercentage"), false);
            return;
        }

        // inicializace stavu a spuštění editace
        setProcessingItems(items);
        SetCompleteFormData({ ...formData, priceEditStarted: true });

        for (let i = 0; i < items.length; i++) {
            const product = items[i];
            //odebereme prefix p- a pv- z ID produktu
            const id = product.rowID.replace(/^p[v]?-/i, "");
            const productType = product.rowID.startsWith("pv-") ? "variant" : "product";

            try {
                await BulkEditProductPrice({
                    variables: {
                        id,
                        productType,
                        isPercentage: formData.isPercentage,
                        operationType: formData.operationType,
                        value: JSON.stringify(formData.value),
                    },
                });
                product.status = "success";
            } catch (e) {
                product.status = "error";
                product.statusMessage = GetApolloErrorText(e);
            }
            // aktualizuji stav, což vyvolá rerender
            setProcessingItems([...items]);
        }
    };

    return {
        formData,
        processingItems,
        StartBulkEdit,
        SetFormData,
        SetCompleteFormData,
    };
};

export default UseSendBulkPriceData;
